/**
 * Quelles pages de contenu existent, et dans quelles langues.
 *
 * UNE LANGUE N'EST DECLAREE QUE SI ELLE EST REELLEMENT TRADUITE. C'est la regle
 * qui tient tout le reste : les `hreflang`, le sitemap et les URL prerendues se
 * deduisent de cette liste. Annoncer une alternative qui n'existe pas fait
 * explorer des 404 et discredite les autres declarations, que Google finit par
 * ignorer en bloc.
 *
 * Une langue absente n'est pas une page vide : l'ecran retombe sur le francais,
 * simplement son URL prefixee n'existe pas et personne ne la lui promet.
 */
import type { Language } from '../locales/index.js';
import type { Article, Page } from './types.js';
import type { FaqEntry, ModeCard, Step } from './fr/home.js';
import type { ModeRow } from './fr/modes.js';

export interface LanguageContent {
  readonly home: {
    readonly intro: readonly string[];
    readonly steps: readonly Step[];
    readonly modes: readonly ModeCard[];
    readonly faq: readonly FaqEntry[];
    /** Titres des quatre sections de l'accueil. */
    readonly headings: {
      readonly intro: string;
      readonly steps: string;
      readonly modes: string;
      readonly faq: string;
      readonly more: string;
    };
    /** Libelles des liens sortants. */
    readonly links: {
      readonly rules: string;
      readonly modes: string;
    };
  };
  readonly howToPlay: Page;
  readonly modes: Page;
  readonly modeTable: readonly ModeRow[];
  readonly modeTableHeadings: readonly [string, string, string];
  readonly premium: { readonly heading: string; readonly blocks: readonly string[] };
  readonly blog: readonly Article[];
  /** Libelles communs aux pages de contenu. */
  readonly ui: {
    readonly atAGlance: string;
    readonly allArticles: string;
    readonly theRules: string;
    readonly theModes: string;
  };
}

/** Chemins des pages de contenu, sans prefixe de langue. */
export const CONTENT_PATHS = ['/how-to-play', '/modes', '/blog'] as const;

/** Prefixe d'URL d'une langue. Le francais garde la racine. */
export function localePrefix(language: Language): string {
  return language === 'fr' ? '' : `/${language}`;
}
